module.exports = __webpack_public_path__ + "static/media/proj9.a80bae17.PNG";